/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { RefreshTokenExpirationService } from './auth/services/refresh-token-expiration.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private config: PrimeNGConfig,
    private translateService: TranslateService,
    private refreshTokenExpirationService: RefreshTokenExpirationService,
  ) {
  }

  ngOnInit() {
    this.analytics.trackPageViews();
    this.translateService.setDefaultLang('pl');
    this.translateService.get('primeng').subscribe(res => {this.config.setTranslation(res);});
    this.refreshTokenExpirationService.startMonitoring();
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
}
}
